import ProductState from "./ProductState";
import { Discount } from "./ProductPageStateSchema";

import Events from "../Utils/Events";
import Hider from "../Utils/Hider";
import DomFactory from "../Utils/DomFactory";

export default class NewCustomerDiscountBubble {
  private readonly element: HTMLElement;

  public constructor(element: HTMLElement) {
    this.element = element;

    Events.on("product-state-change", (s: ProductState) => this.updateDiscount(s));
    Events.fire("product-state-change-request", this);
  }

  private updateDiscount(state: ProductState) {
    const discount: Discount | null = state.quantity.discount;
    Hider.match(this.element, discount != null && discount.newCustomerOnly && !state.frequency);
  }

  public static Factory: DomFactory<NewCustomerDiscountBubble> = (e) => new NewCustomerDiscountBubble(e);
}
